import {post} from "../../modules/ajax";
import {dispatchCustomEvent} from "../../modules/events";
import {getLastViewedProducts} from "./last-viewed-storage";

export function renderLastViewedProductsBlock(container)
{
    post(
        '/ajax/website/product-list/get-last-viewed-products-recommender',
        {lastViewedProducts: getLastViewedProducts()},
        function(data) {
            if (data.recommender === '') {
                container.remove();
                return;
            }
            container.innerHTML = data.recommender;
            dispatchCustomEvent('lastViewedProductsRendered', {container: container});
        }
    );
}
